import { useState, useEffect, useRef } from 'react';

export default function SocialMediaProcess() {
  const [activeStep, setActiveStep] = useState(0);

  const steps = [
    {
      number: "01",
      title: "Analyse & Strategie",
      description: "Wir analysieren Ihre aktuelle Präsenz, definieren Ziele und entwickeln eine maßgeschneiderte Social Media Strategie.",
      icon: "ri-search-line",
      details: [
        "Competitor-Analyse",
        "Zielgruppen-Definition",
        "Content-Strategie",
        "KPI-Festlegung"
      ]
    },
    {
      number: "02",
      title: "Content Creation",
      description: "Erstellung von hochwertigem, plattformspezifischem Content, der Ihre Zielgruppe anspricht und Engagement generiert.",
      icon: "ri-palette-line",
      details: [
        "Visual Design",
        "Copywriting",
        "Video-Produktion",
        "Content-Kalender"
      ]
    },
    {
      number: "03",
      title: "Community Management",
      description: "Aktive Betreuung Ihrer Community, Interaktion mit Followern und Aufbau einer loyalen Fanbase.",
      icon: "ri-team-line",
      details: [
        "Daily Monitoring",
        "Kommentar-Management",
        "Influencer Relations",
        "Crisis Management"
      ]
    },
    {
      number: "04",
      title: "Paid Advertising",
      description: "Strategische Werbekampagnen für maximale Reichweite und optimale Conversion-Raten.",
      icon: "ri-megaphone-line",
      details: [
        "Kampagnen-Setup",
        "A/B Testing",
        "Budget-Optimierung",
        "Retargeting"
      ]
    },
    {
      number: "05",
      title: "Analytics & Reporting",
      description: "Kontinuierliche Erfolgsmessung und Optimierung basierend auf detaillierten Analysen und Reports.",
      icon: "ri-bar-chart-line",
      details: [
        "Performance Tracking",
        "ROI-Analyse",
        "Monthly Reports",
        "Strategie-Anpassung"
      ]
    }
  ];

  return (
    <section id="process" className="py-24 bg-black">
      <div className="container mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-20">
          <div className="flex items-center justify-center space-x-3 text-[#d1bc8a] mb-6">
            <div className="w-2 h-2 bg-[#d1bc8a] rounded-full animate-pulse"></div>
            <span className="text-sm uppercase tracking-wider">Unser Prozess</span>
          </div>
          <h2 className="text-4xl md:text-6xl font-bold text-white mb-6">
            So arbeiten
            <span className="block text-[#d1bc8a]">
              wir zusammen
            </span>
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            Von der ersten Analyse bis zum kontinuierlichen Erfolg - 
            unser bewährter 5-Schritte-Prozess für nachhaltigen Social Media Erfolg.
          </p>
        </div>

        {/* Process Steps */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Steps List */}
          <div className="space-y-6">
            {steps.map((step, index) => (
              <div
                key={index}
                className={`group cursor-pointer transition-all duration-500 ${
                  activeStep === index ? 'scale-105' : 'hover:scale-102'
                }`}
                onClick={() => setActiveStep(index)}
              >
                <div className={`bg-zinc-900 p-6 rounded-2xl border transition-all duration-500 ${
                  activeStep === index
                    ? 'border-[#d1bc8a] shadow-lg shadow-[#d1bc8a]/20'
                    : 'border-zinc-800 hover:border-[#d1bc8a]/40'
                }`}>
                  <div className="flex items-start space-x-4">
                    {/* Step Number */}
                    <div className={`w-12 h-12 rounded-xl flex items-center justify-center font-bold text-lg transition-all duration-300 ${
                      activeStep === index
                        ? 'bg-[#d1bc8a] text-black'
                        : 'bg-zinc-800 text-gray-400'
                    }`}>
                      {step.number}
                    </div>

                    {/* Content */}
                    <div className="flex-1">
                      <h3 className={`text-xl font-bold mb-2 transition-colors duration-300 ${
                        activeStep === index ? 'text-[#d1bc8a]' : 'text-white'
                      }`}>
                        {step.title}
                      </h3>
                      <p className="text-gray-400 leading-relaxed">
                        {step.description}
                      </p>
                    </div>

                    {/* Icon */}
                    <div className={`w-10 h-10 rounded-lg flex items-center justify-center transition-all duration-300 ${
                      activeStep === index
                        ? 'bg-[#d1bc8a]/20 text-[#d1bc8a]'
                        : 'bg-zinc-800 text-gray-400'
                    }`}>
                      <i className={`${step.icon} text-lg`}></i>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Active Step Details */}
          <div className="lg:pl-8">
            <div className="bg-zinc-900 rounded-2xl p-8 border border-zinc-800">
              {/* Icon */}
              <div className="w-16 h-16 bg-[#d1bc8a] rounded-xl flex items-center justify-center mb-6">
                <i className={`${steps[activeStep].icon} text-black text-2xl`}></i>
              </div>

              {/* Title */}
              <h3 className="text-2xl font-bold text-white mb-4">
                {steps[activeStep].title}
              </h3>

              {/* Description */}
              <p className="text-gray-400 mb-8 leading-relaxed">
                {steps[activeStep].description}
              </p>

              {/* Details */}
              <div className="space-y-3">
                <h4 className="text-[#d1bc8a] font-semibold mb-4">Was wir für Sie tun:</h4>
                {steps[activeStep].details.map((detail, index) => (
                  <div key={index} className="flex items-center text-gray-400">
                    <div className="w-2 h-2 bg-[#d1bc8a] rounded-full mr-3"></div>
                    {detail}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>


      </div>
    </section>
  );
}